import React, { useState, useEffect } from "react"
import { Button, Card, CardBody, Table } from "reactstrap"
import { connect } from "react-redux"
import { useParams } from "react-router-dom"
import { useWallet } from "../libs/useMetaMaskWallet"
import LoginToMetamask from "./LoginToMetamask"
import NFTPrefs from "./NFTPrefs.json"
import queryString from "query-string"
import OkDialog from "../Pages/OkDialog"
import { setKycStatus } from "../store/common/commonActions"

const authUrl = `${NFTPrefs.frontendServer}/authorize?client_id=${process.env.REACT_APP_FRACTAL_CLIENT_ID}&redirect_uri=${NFTPrefs.redirectUri}&response_type=code&scope=${NFTPrefs.scope}`
const userUrl = `${NFTPrefs.resourceServer}/users/me`

const NFTCheck = (props) => {
    const wallet = useWallet()
    const { code } = useParams()
    const [user, setUser] = useState({})
    const { networkOptionStatus, validationStatus, pointBalance, kycStatus, setKycStatus } = props
    const [kycProcessed, setKycProcessed] = useState(false)
    const [verificationCases, setVerifications] = useState([])
    const [dialogOpen, setDialog] = useState(false)

    const capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1)
    }

    const handleClickLogIn = (e) => {
        let refreshToken = localStorage.getItem("refreshToken")
        if (refreshToken) {
            return refreshProcess(refreshToken)
        } else if (validationStatus === "Validated") {
            window.open(authUrl, "_self")
        } else {
            setDialog(true)
        }
    }

    const getUser = (accessToken) => {
        return fetch(userUrl, {
            method: "GET",
            headers: { Authorization: `Bearer ${accessToken}` }
        })
            .then((res) => res.json())
            .then((res) => {
                setKycProcessed(true)
                setVerifications(res.verification_cases)
                let status = res.verification_cases.length === 0 ? kycStatus : res.verification_cases[0].credential

                // set user's fractal id in localStorage (so we can grab it later in NFTUpgrade page)
                let userFractalId = res.uid
                localStorage.setItem("userFractalId", userFractalId)

                setKycStatus(status)
            })
    }

    const refreshProcess = (refreshToken) => {
        return fetch("https://fractaloauth.idexo.io", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                token: localStorage.jwtToken
            },
            body: JSON.stringify({
                refresh_token: refreshToken
            })
        })
            .then((res) => res.json())
            .then((res) => {
                localStorage.setItem("accessToken", res.data.access_token)
                localStorage.setItem("refreshToken", res.data.refresh_token)
                return getUser(res.data.access_token)
            })
            .catch((error) => {
                console.log(error)
            })
    }

    const loginProcess = (code, redirect_uri) => {
        fetch("https://fractaloauth.idexo.io", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                token: localStorage.jwtToken
            },
            body: JSON.stringify({
                code: code,
                redirect_uri: redirect_uri
            })
        })
            .then((res) => res.json())
            .then((res) => {
                localStorage.setItem("accessToken", res.data.access_token)
                localStorage.setItem("refreshToken", res.data.refresh_token)
                return getUser(res.data.access_token)
            })
            .catch((error) => {
                console.log(error)
            })
    }

    useEffect(() => {
        ;(async () => {
            let refreshToken = localStorage.getItem("refreshToken")
            if (refreshToken) {
                return refreshProcess(refreshToken)
            } else if (!kycProcessed) {
                const { code } = queryString.parse(window.location.search)
                if (code) {
                    try {
                        return loginProcess(code, NFTPrefs.redirectUri)
                    } catch (error) {
                        console.error(error)
                    }
                }
            }
        })()
    }, [kycProcessed])

    let kycStatusValues = verificationCases.map((verification, i) => {
        return (
            <div key={i}>
                <span className="validate-nft-kycstatus-pending">{capitalizeFirstLetter(verification.status)}, </span>
                <span> Credential: {capitalizeFirstLetter(verification.credential)}</span>
            </div>
        )
    })

    return (
        <React.Fragment>
            {wallet.account ? (
                <div className="content nftcheck">
                    <Card>
                        <CardBody>
                            <Table className="align-middle mb-0 table-nowrap nftcheckTable">
                                <thead className="table-light">
                                    <tr className="nftcheck-tr">
                                        <th scope="col">Wallet Address</th>
                                        <th scope="col">Network</th>
                                        <th scope="col">Validation Status</th>
                                        <th scope="col">KYC Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="nftcheck-tr">
                                        <td className="nftcheck-address">{wallet.account}</td>
                                        <td className="nftcheck-values">{networkOptionStatus}</td>
                                        <td className="nftcheck-values">{validationStatus}</td>
                                        <td className="nftcheck-values">{kycStatus === "Not Started" ? "Not Started" : kycStatusValues}</td>
                                    </tr>
                                </tbody>
                            </Table>
                            <div className="nftcheck-login">
                                    <Button color="light" className="fractal-id-btn">
                                        Sold Out
                                    </Button>
                            </div>
                        </CardBody>
                    </Card>

                    <OkDialog open={dialogOpen} title={""} message={"Sorry we can not detect a valid NFT."} okClick={() => setDialog(false)} />
                </div>
            ) : (
                <LoginToMetamask />
            )}
        </React.Fragment>
    )
}

const mapStateToProps = (state) => ({
    networkOptionStatus: state.commonReducer.networkOptionStatus,
    validationStatus: state.commonReducer.validationStatus,
    pointBalance: state.commonReducer.pointBalance,
    kycStatus: state.commonReducer.kycStatus
})

const mapDispatchToProps = {
    setKycStatus
}

export default connect(mapStateToProps, mapDispatchToProps)(NFTCheck)
